<script lang="ts">
    import translate from '../../../../lib/translate'
    import { buttonStore as button } from '../../stores'
    import { ButtonState } from '../../types/Bids'
    import {createEventDispatcher} from 'svelte'
    import label from './BidButton.translation'

    const buttonColor = (state: ButtonState): string => {
        if( state === ButtonState.pleaseWait || 
            state === ButtonState.productSold || 
            state === ButtonState.variantSold || 
            state === ButtonState.chooseVariant
        ) {
            return 'grey'
        }
        if( state === ButtonState.bidSuccessful) {
            return 'green'
        }
        if( state === ButtonState.confirmBid) {
            return 'orange'
        }
        return ''
    }
    const dispatch = createEventDispatcher()
    const buttonClicked = (state) => {
        dispatch('bidButtonClick', {
            state : state
        })
    }
</script>

{#if $button !== ButtonState.none}
    <span class="auction-button btn {buttonColor($button)}" on:click={() => buttonClicked($button)}>
        {translate(label.btnStatus($button))}
    </span>
{/if}